export const frequency = {
  1440: 'every day',
  2880: 'every 2 days',
  4320: 'every 3 days',
  5760: 'every 4 days',
  7200: 'every 5 days',
  8640: 'every 6 days',
  10080: 'every 7 days',
};



// WEBPACK FOOTER //
// ./src/pages/filings/SearchCourtRecords/ReportsTab/ReportsTabForms/AutomateReportAndDelivery/AutomateReportAndDeliveryOptions.js